import { render, staticRenderFns } from "./OrderRecord.vue?vue&type=template&id=07a16a6c&scoped=true&"
import script from "./OrderRecord.vue?vue&type=script&lang=js&"
export * from "./OrderRecord.vue?vue&type=script&lang=js&"
import style0 from "./OrderRecord.vue?vue&type=style&index=0&id=07a16a6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a16a6c",
  null
  
)

export default component.exports